import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VuetifyDialog from 'vuetify-dialog'
import VueAxios from 'vue-axios'
import axios from 'axios'
// import style
import 'swiper/css/swiper.css'

axios.defaults.baseURL = process.env.VUE_APP_API
axios.defaults.headers.common['Authorization'] = 'SCCC_TRAINEE'
Vue.use(VueAxios, axios)
Vue.use(VuetifyDialog, { context: { vuetify } })
Vue.use(VueAwesomeSwiper /* { default options with global component } */)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
